import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=418c96ca&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=418c96ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c96ca",
  null
  
)

export default component.exports